export default __webpack_public_path__ + "static/Bilo Bold-d2559733a989024e437b776583da2e7b.otf";